{
  "welcome": {
    "title": "Selamat datang, {{name}}",
    "title_noName": "Selamat datang di Rhemn",
    "body": "Apa pun yang berpendar akan menunjukkan fungsinya. Jelajahi dengan urutan mana pun, kapan pun Anda mau.",
    "start": "Mulai menjelajah",
    "later": "Nanti saja"
  },
  "card": {
    "tryIt": "Coba",
    "takeALook": "Lihat dulu",
    "pro": "Bagian dari Rhemn Pro",
    "close_aria": "Tutup"
  },
  "pill": {
    "progress": "{{count}} dari {{total}} dijelajahi",
    "progress_short": "{{count}} dari {{total}}",
    "done": "Selesai",
    "done_aria": "Selesai menjelajah",
    "complete": "Semua sudah dijelajahi"
  },
  "sr": {
    "started": "Mode jelajah aktif. Tombol menunjukkan fungsinya sebelum dijalankan.",
    "hint": "Mode jelajah. Menunjukkan fungsinya terlebih dahulu.",
    "ended": "Mode jelajah nonaktif."
  },
  "settings": {
    "row": "Cara kerja Rhemn",
    "row_sub": "Sekilas tentang setiap bagian",
    "row_aria": "Cara kerja Rhemn: jelajahi aplikasi lagi",
    "helpCaption": "Bantuan"
  },
  "steps": {
    "intention": {
      "title": "Niat hari ini",
      "body": "Tulis satu hal yang paling penting hari ini, lalu centang saat selesai."
    },
    "now": {
      "title": "Hari Anda, menurut salat",
      "body": "Rhemn membagi hari Anda di setiap waktu salat. Ini menunjukkan sisa waktu hingga salat berikutnya dan rencana Anda untuk rentang itu."
    },
    "verse": {
      "title": "Wawasan ayat",
      "body": "Ajukan pertanyaan tentang ayat hari ini, baca tafsir singkat, dan temukan ayat dengan tema yang sama."
    },
    "qibla": {
      "title": "Kiblat",
      "body_chrome": "Arah Ka'bah dari lokasi Anda, dalam derajat dari utara.",
      "body_ios": "Menunjuk ke arah Ka'bah dari lokasi Anda. Nyalakan kompas langsung, dan arahnya mengikuti saat Anda berbalik."
    },
    "prayer": {
      "title": "Waktu salat",
      "body_chrome": "Lima waktu salat hari ini untuk lokasi Anda. Pilih metode perhitungan yang diikuti masjid Anda.",
      "body_ios": "Salat berikutnya dalam sekilas. Buka untuk melihat kelima waktu dan pengingat untuk masing-masing."
    },
    "tasks": {
      "title": "Tugas",
      "body": "Susun tugas Anda dalam daftar, dan beri setiap tugas tempat di antara waktu salat."
    },
    "notes": {
      "title": "Catatan",
      "body_chrome": "Tulis, atau cukup bicara. Rhemn mentranskripsikan catatan suara dan rapat Anda, lalu merangkumnya.",
      "body_ios": "Tulis, atau cukup bicara. Rhemn mengubah ucapan Anda menjadi catatan yang rapi dan terangkum."
    },
    "profile": {
      "title_chrome": "Profil Anda",
      "body_chrome": "Pengaturan akun dan privasi Anda. Kembali ke sini untuk menjelajahi Rhemn lagi.",
      "title_ios": "Lainnya",
      "body_ios": "Ayat tersimpan, Kiblat, dan pengaturan akun Anda. Anda bisa menjelajahi Rhemn lagi dari sini."
    }
  }
}
